import React from 'react';
import { CLEAR_POOL_IMAGE, INDEPENDENCE_GOAL, INDEPENDENCE_GOAL_NOT, INDEPENDENCE_HEADLINE, independenceBody, independenceStatement } from '../data/poolContent';
export function IndependenceSection() {
  return <section className="w-full bg-abyss-950" aria-labelledby="independence-title" data-id="element-214" data-mp="3rl4h3qjk4fhd">
      <img src={CLEAR_POOL_IMAGE} alt="Crystal-clear illuminated pool at night" className="h-56 w-full object-cover sm:h-80 lg:h-[26rem]" width={1600} height={900} loading="lazy" data-id="element-215" data-mp="cgvd9hemq9a" />
      <div className="mx-auto max-w-4xl px-5 py-14 text-center sm:py-20" data-id="element-216" data-mp="33ui91z9jyv7d">
        <h2 id="independence-title" className="font-display text-[2.1rem] font-bold uppercase leading-none text-frost-50 sm:text-[3rem]" data-id="element-217" data-mp="38sjs4k6zauiu">
          {INDEPENDENCE_HEADLINE}
        </h2>
        {independenceBody.map(line => <p key={line} className="mx-auto mt-4 max-w-2xl text-[15px] leading-relaxed text-body sm:text-[16px]" data-id="element-218" data-mp="2l3hc1grzt9qg">
            {line}
          </p>)}
        <div className="mx-auto mt-8 max-w-2xl border-y border-abyss-600 py-6" data-id="element-219" data-mp="1khwxkf9s2dhs">
          <p className="text-[15px] text-muted" data-id="element-220" data-mp="1fkn2ok3md9mk">{INDEPENDENCE_GOAL_NOT}</p>
          <p className="mt-2 text-[16px] font-semibold text-frost-50 sm:text-[18px]" data-id="element-221" data-mp="1as3n5hldg4f4">
            {INDEPENDENCE_GOAL}
          </p>
        </div>

        <p className="mt-12 font-display text-[2.6rem] font-bold uppercase leading-[0.95] text-frost-50 sm:text-[4rem]" data-id="element-222" data-mp="16qrybeabnn7z">
          {independenceStatement.map((line, i) => <span key={line} className={`block ${i === independenceStatement.length - 1 ? 'text-aqua' : ''}`} data-id="element-223" data-mp="ws2p09whrb3c" data-mpi={i}>
              {line}
            </span>)}
        </p>
      </div>
    </section>;
}